import { AxiosInstance } from "axios";
import { ArchiConversation, ArchiMessageRow } from "./types";
import { readEventStream } from "./sse";

const BASE = "/chat/archi";

interface Envelope<T> {
  success: boolean;
  data: T;
  message?: string;
}

export async function listConversations(api: AxiosInstance) {
  const res = await api.get<Envelope<ArchiConversation[]>>(`${BASE}/conversations`);
  return res.data.data;
}

export async function getMessages(api: AxiosInstance, id: number) {
  const res = await api.get<
    Envelope<{ conversation: ArchiConversation; messages: ArchiMessageRow[] }>
  >(`${BASE}/conversations/${id}/messages`);
  return res.data.data;
}

export async function deleteConversation(api: AxiosInstance, id: number) {
  await api.delete<Envelope<null>>(`${BASE}/conversations/${id}`);
}

export async function renameConversation(
  api: AxiosInstance,
  id: number,
  title: string
) {
  const res = await api.patch<Envelope<ArchiConversation>>(
    `${BASE}/conversations/${id}`,
    { title }
  );
  return res.data.data;
}

/** SSE stream of an Archi reply from chopper-backend (see `readEventStream`). */
export async function streamMessage(
  opts: {
    token: string;
    apiBaseUrl: string;
    body: {
      conversationId?: number | null;
      message: string;
      currentRoute?: string | null;
    };
    onEvent: (event: string, data: unknown) => void;
    signal?: AbortSignal;
  }
): Promise<void> {
  const { token, apiBaseUrl, body, onEvent, signal } = opts;
  const url = `${apiBaseUrl.replace(/\/$/, "")}/v1/chat/archi/messages`;
  const resp = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "text/event-stream",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
    signal,
  });

  await readEventStream(resp, onEvent);
}
